function sssSetMobileStickyAtcHidden(hidden) {
  if (window.matchMedia && !window.matchMedia("(max-width: 989px)").matches) return;

  document.querySelectorAll(".product-sticky-add-bar").forEach((bar) => {
    if (hidden) {
      bar.dataset.sssBagHidden = "true";
      bar.style.setProperty("display", "none", "important");
      bar.style.setProperty("visibility", "hidden", "important");
      bar.style.setProperty("pointer-events", "none", "important");
      bar.setAttribute("aria-hidden", "true");
    } else if (bar.dataset.sssBagHidden === "true") {
      delete bar.dataset.sssBagHidden;
      bar.style.removeProperty("display");
      bar.style.removeProperty("visibility");
      bar.style.removeProperty("pointer-events");
      bar.removeAttribute("aria-hidden");
    }
  });
}

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    this.querySelector("#CartDrawer-Overlay").addEventListener(
      "click",
      this.close.bind(this)
    );
    this.setHeaderCartIconAccessibility();
  }

  resetNotificationView() {
    const notification = this.querySelector(".notification");
    if (!notification) return;

    notification.classList.remove("notification-open");
    this.querySelectorAll(".cart-item.active").forEach((item) =>
      item.classList.remove("active")
    );
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector("#cart-icon-bubble");
    if (!cartLink) return;
    // Desktop and mobile bag icon use the native full /cart page.
    // The product add-to-cart drawer remains available.
    cartLink.removeAttribute("role");
    cartLink.removeAttribute("aria-haspopup");
  }

  open(triggeredBy) {
    sssSetMobileStickyAtcHidden(true);
    // A deliberate cart-icon open should always show the complete bag, not a
    // stale post-add notification state that can hide regular cart lines.
    if (triggeredBy) this.resetNotificationView();
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerSummaries = this.querySelectorAll(
      '[id^="Details-"] summary'
    );
    cartDrawerSummaries.forEach((summary) => {
      if (!summary.hasAttribute("role")) this.setSummaryAccessibility(summary);
    });

    setTimeout(() => {
      this.classList.add("animate", "active");
    });

    this.addEventListener(
      "transitionend",
      () => {
        const containerToTrapFocusOn = document.getElementById("CartDrawer");
        const focusElement = this.querySelector(".drawer__close");

        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add("cart-overflow-hidden");
    document.body.classList.add("overflow-hidden");
  }

  close() {
    sssSetMobileStickyAtcHidden(false);
    this.classList.remove("active");
    removeTrapFocus(this.activeElement);
    document.body.classList.remove("cart-overflow-hidden");
    document.body.classList.remove("overflow-hidden");

    setTimeout(() => {
      this.resetNotificationView();
    }, 1000);
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute("role", "button");
    cartDrawerNote.setAttribute("aria-expanded", "false");

    if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
      cartDrawerNote.setAttribute(
        "aria-controls",
        cartDrawerNote.nextElementSibling.id
      );
    }

    cartDrawerNote.addEventListener("click", (event) => {
      event.currentTarget.setAttribute(
        "aria-expanded",
        !event.currentTarget.closest("details").hasAttribute("open")
      );
    });

    cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector(".drawer__inner").classList.contains("is-empty") &&
      this.querySelector(".drawer__inner").classList.remove("is-empty");
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    let notification = this.querySelector(".notification");

    if (notification) {
      const activeItem = this.querySelector(
        `.cart-item[data-product-id="${this.productId}"]`
      );

      this.querySelectorAll(".cart-item.active").forEach((item) =>
        item.classList.remove("active")
      );

      // Only use the compact notification state when Shopify can positively
      // identify the added cart line. Otherwise fall back to the full bag so
      // no cart item can disappear behind notification-only CSS.
      if (activeItem) {
        notification.classList.add("notification-open");
        activeItem.classList.add("active");
      } else {
        notification.classList.remove("notification-open");
      }
    }

    setTimeout(() => {
      this.querySelector("#CartDrawer-Overlay").addEventListener(
        "click",
        this.close.bind(this)
      );
      sssSetMobileStickyAtcHidden(true);
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-drawer",
        selector: "#CartDrawer",
      },
      {
        id: "cart-icon-bubble",
      },
    ];
  }

  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: "CartDrawer",
        section: "cart-drawer",
        selector: ".drawer__inner",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
    ];
  }
}

customElements.define("cart-drawer-items", CartDrawerItems);

if (!customElements.get("cart-note")) {
  customElements.define(
    "cart-note",
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          "input",
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, {
              ...fetchConfig(),
              ...{ body },
            });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}

//if (!customElements.get("cart-discount-code")) {
//  customElements.define(
//    "cart-discount-code",
//    class CartDiscountCode extends HTMLElement {
//      constructor() {
//        super();
//
//        this.onSubmit = this.onSubmit.bind(this);
//      }
//
//      connectedCallback() {
//        this.form = this.querySelector(".cart-discount-code__form");
//        this.input = this.querySelector('input[name="discount"]');
//
//        if (!this.form || !this.input) return;
//        this.form.addEventListener("submit", this.onSubmit);
//      }
//
//      disconnectedCallback() {
//        this.form?.removeEventListener("submit", this.onSubmit);
//      }
//
//      onSubmit(event) {
//        console.log("Submitted");
//        const code = this.input.value.trim();
//
//        if (!code) {
//          event.preventDefault();
//          this.input.focus();
//          return;
//        }
//
//        event.preventDefault();
//
//        const redirectInput = this.form.querySelector('input[name="redirect"]');
//        const oseidInput = this.form.querySelector('input[name="oseid"]');
//        const redirectTarget =
//          redirectInput?.value || `${window.Shopify.routes.root}cart`;
//
//        const discountUrl = new URL(
//          `${window.Shopify.routes.root}discount/${encodeURIComponent(code)}`,
//          window.location.origin
//        );
//
//        discountUrl.searchParams.set("redirect", redirectTarget);
//
//        if (oseidInput?.value) {
//          discountUrl.searchParams.set("oseid", oseidInput.value);
//        }
//
//        console.log("1111111", discountUrl.toString());
//
//        window.location.assign(discountUrl.toString());
//      }
//    }
//  );
//}

/*
 * Spring Step cart-drawer layout guard.
 * The merchandising upsells are intentionally kept after the shopper's
 * actual cart lines inside the native scroll region. This prevents a large
 * upsell sibling from shrinking the cart-items flex area to zero height.
 */
(function initSpringStepCartDrawerGuard() {
  const placeUpsells = (drawer) => {
    if (!drawer) return;

    const cartBody = drawer.querySelector("#CartDrawer-CartItems");
    const nativeItems = cartBody?.querySelector(".drawer__cart-items-wrapper");
    const upsells = drawer.querySelector(".roy-cart-upsells");

    if (!cartBody || !nativeItems || !upsells) return;

    if (
      upsells.parentElement !== cartBody ||
      nativeItems.nextElementSibling !== upsells
    ) {
      nativeItems.insertAdjacentElement("afterend", upsells);
    }
  };

  const attach = () => {
    const drawer = document.querySelector("cart-drawer");
    if (!drawer || drawer.dataset.sssLayoutGuard === "true") return;

    drawer.dataset.sssLayoutGuard = "true";
    placeUpsells(drawer);

    let timer;
    new MutationObserver(() => {
      clearTimeout(timer);
      timer = setTimeout(() => placeUpsells(drawer), 30);
    }).observe(drawer, { subtree: true, childList: true });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", attach, { once: true });
  } else {
    attach();
  }
})();


/* SSS mobile bag sticky ATC hard guard - Sep 24 */
(function initMobileBagStickyAtcGuard() {
  const sync = () => {
    const drawer = document.querySelector("cart-drawer");
    const onCartPage =
      document.body.classList.contains("template-cart") ||
      window.location.pathname.replace(/\/$/, "") === "/cart";
    const drawerOpen =
      !!drawer?.classList.contains("active") ||
      document.body.classList.contains("cart-overflow-hidden");

    sssSetMobileStickyAtcHidden(onCartPage || drawerOpen);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", sync, { once: true });
  } else {
    sync();
  }

  const observer = new MutationObserver(sync);
  observer.observe(document.documentElement, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ["class"]
  });
})();
